import { hexToWorld } from '@somnhold/sim';

type Cell = { q: number; r: number };

/**
 * How a building on several cells turns (rotation round Y, front +Z), as near facing the keep as its cells let it.
 * Three cells: its length (model X) runs from the middle of the triangle out into one of them, the only way a long
 * building stays on its own cells (turned freely to the keep it stood askew, half over a neighbour's). The Titan's
 * Eye (a centre and its ring): by its ring, so each of its six plinths stands on a ring cell.
 */
export const footYaw = (q: number, r: number, foot: Cell[]): number => {
  const huge = foot.length >= 6;
  const cells = huge ? foot : [{ q, r }, ...foot];
  // The centre the building stands on: the ring's middle cell, or the triangle's middle.
  let cx = 0;
  let cy = 0;
  if (huge) {
    const c = hexToWorld(q, r);
    cx = c.x;
    cy = c.y;
  } else {
    for (const h of cells) {
      const w = hexToWorld(h.q, h.r);
      cx += w.x / cells.length;
      cy += w.y / cells.length;
    }
  }
  const want = Math.atan2(-cx, -cy);
  let best = want;
  let bestD = Infinity;
  for (const h of cells) {
    const w = hexToWorld(h.q, h.r);
    const a = Math.atan2(w.x - cx, w.y - cy);
    for (const yaw of huge ? [a] : [a + Math.PI / 2, a - Math.PI / 2]) {
      const d = Math.abs(Math.atan2(Math.sin(yaw - want), Math.cos(yaw - want)));
      if (d < bestD) {
        bestD = d;
        best = yaw;
      }
    }
  }
  return best;
};
